import React from 'react';
import SimpleDialog from '../SimpleDialog/SimpleDialog';
import { BidDTO, BidOption, BidRow, ConflictDTO } from '../../../store/bid/types';
import { Button, Checkbox } from '../../ui';
import { can } from '../../../helpers/permissions';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  handleClose: () => void;
  bidOptionsById: { [key: number]: BidOption };
  createBidAction: (data: BidDTO) => void;
  submission: BidRow;
  postConflict: (data: ConflictDTO) => void;
}

const EditBidOptionDialog: React.FC<Props> = ({
  handleClose,
  bidOptionsById,
  createBidAction,
  submission,
  postConflict,
}) => {
  const { t } = useTranslation();
  const submission_id = submission.bidable_id;
  const [conflict, setConflict] = React.useState(!!submission.conflict);
  const [selectedBidOptionId, setSelectedBidOptionId] = React.useState<number | null>(submission.bid_option_id);

  return (
    <SimpleDialog cancelButtonText={t('Close')} handleClose={handleClose}>
      <StyledCheckWrapper className="mb-8 flex justify-center py-8">
        <Checkbox
          className="mb-2"
          label={t('Declare conflict')}
          checked={conflict}
          disabled={!can('CAN_EDIT_BID')}
          onChange={(event) => {
            const isChecked = event.target.checked;
            setConflict(isChecked);
            postConflict({ submission_id, conflict: isChecked });

            if (isChecked) {
              setSelectedBidOptionId(null);

              createBidAction({
                bidable_id: submission.bidable_id,
                bid_option_id: null,
              });
            }
          }}
        />
      </StyledCheckWrapper>
      <div className="flex flex-col justify-center items-center gap-4">
        {Object.values(bidOptionsById).map((bidOption, index) => {
          return (
            <Button
              key={index}
              className={`mobileCtrlBidOptionButton ${selectedBidOptionId === bidOption.id ? 'selected' : ''}`}
              disabled={!can('CAN_EDIT_BID') || conflict}
              onClick={() => {
                const isSelected = selectedBidOptionId === bidOption.id;
                const newBidOptionId = isSelected ? null : bidOption.id;
                setSelectedBidOptionId(newBidOptionId);

                createBidAction({
                  bidable_id: submission.bidable_id,
                  bid_option_id: newBidOptionId,
                });
                //handleClose();
              }}
            >
              {bidOption.name}
            </Button>
          );
        })}
      </div>
    </SimpleDialog>
  );
};

export default EditBidOptionDialog;

const StyledCheckWrapper = styled.div`
  border-bottom: 1px dashed;
`;
